import { render, staticRenderFns } from "./tougheningBatch.vue?vue&type=template&id=9bd696a6&"
import script from "./tougheningBatch.vue?vue&type=script&lang=js&"
export * from "./tougheningBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports